export default "__VITE_ASSET__6d937361__"